<template>
  <div
    ref="trigger"
    v-click-outside="handleClickOutside"
    class="relative cursor-pointer flex justify-end"
    @click="open = !open"
  >
    <button class="btn btn-outline-gray min-w-24 justify-between">
      <span>Actions</span>
      <i class="fa-solid fa-sharp fa-caret-down text-center group-hover:text-white" />
    </button>

    <div
      v-show="open"
      ref="floating"
      :style="floatingStyles"
      class="bg-white shadow rounded border z-[70] min-w-max"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { flip, offset, useFloating } from '@floating-ui/vue';
import { onMounted, ref } from 'vue';

const open = ref(false);
const trigger = ref();
const floating = ref();

let floatingStyles;

onMounted(() => {
  const { floatingStyles: styles } = useFloating(trigger, floating, {
    middleware: [
      offset(5),
      flip({ }),
    ],
    open,
    placement: 'bottom-end',
  });

  floatingStyles = styles;
});

const handleClickOutside = () => {
  open.value = false;
};
</script>
